import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VerificationCustomerInfoComponent } from './verification-customer-info/verification-customer-info.component';
import { VerificationCustomerComponent } from './verification-customer.component';

const routes: Routes = [
  {path: '', component: VerificationCustomerComponent},
  { path: 'detail/:id' , component: VerificationCustomerInfoComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VerificationCustomerRoutingModule { }
